import { render, staticRenderFns } from "./supplierPerformanceGrade.vue?vue&type=template&id=328b8e23&scoped=true"
import script from "./supplierPerformanceGrade.vue?vue&type=script&lang=js"
export * from "./supplierPerformanceGrade.vue?vue&type=script&lang=js"
import style0 from "./supplierPerformanceGrade.vue?vue&type=style&index=0&id=328b8e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b8e23",
  null
  
)

export default component.exports